import React from 'react';
import './WhyStudents.css';
import topLeftPattern from '../../Assets/parapattern.png';   // ⬅ your actual image path
import bottomRightPattern from '../../Assets/parapattern2.png'; // ⬅ your actual image path

const WhyStudents = () => {
  return (
    <section className="why-stu container">
      {/* Pattern images */}
      <img src={topLeftPattern} alt="" className="pattern top-left" />
      <img src={bottomRightPattern} alt="" className="pattern bottom-right" />

      <div className='row text-center'>
        <div className='col'>
          <h2 className='mb-4 heading'>Why Students Choose Nova EduBridge</h2>
          <p className='whystup mb-2 text-start text-muted'>
            Our students often say that we go beyond being study abroad consultants—we are mentors, motivators, and problem-solvers. We provide clarity in an overwhelming process, making sure students understand every step. Our expertise extends to both high-demand and niche areas, including study medicine abroad, study abroad masters programs, and specialized research courses.
          </p>
          <p className='whystup mb-5 text-start text-muted'>
            We are also aware that the decision to study abroad isn’t just about academics—it’s about building a future. That’s why we incorporate career counselling into our services, guiding students on how to align their education with careers abroad, jobs abroad, and international job markets. Whether it’s exploring USA job portals, seeking employment in Europe, or finding industry-specific opportunities in Asia, we give you the tools to succeed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyStudents;
